import PropTypes from "prop-types"
import React, { Component, Suspense } from "react"
import Button from "semantic-ui-react/dist/es/elements/Button/Button"
import Icon from "semantic-ui-react/dist/es/elements/Icon/Icon"
import List from "semantic-ui-react/dist/es/elements/List/List"
import Modal from "semantic-ui-react/dist/es/modules/Modal/Modal"
import { useStore } from "store"
import { Loader } from "uikit"
import Markdown from "markdown-to-jsx"

const FaqModal = ({ label, onClose, faqId }) => {
  const [{ content }] = useStore("faqs", faqId)
  return (
    <Suspense fallback={<Loader />}>
      <Modal size="small" defaultOpen onClose={onClose}>
        <Modal.Header>{label}</Modal.Header>
        <Modal.Content>
          <Markdown>{content}</Markdown>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} content="Got It!" primary />
        </Modal.Actions>
      </Modal>
    </Suspense>
  )
}

class FaqLinks extends Component {
  state = {
    isModalOpen: false,
    linkId: "",
    linkLabel: "",
    content: "",
    showLoader: false
  }

  handleClose = () =>
    this.setState({ isModalOpen: false, linkId: null, linkLabel: null })
  render = () => {
    return (
      <>
        {this.props.items.length === 1 ? (
          <span
            className="navlink"
            style={{ cursor: "pointer" }}
            onClick={() =>
              this.setState({
                linkId: this.props.items[0].id,
                linkLabel: this.props.items[0].label,
                isModalOpen: true
              })
            }
          >
            {this.props.items[0].label}
          </span>
        ) : (
          <List>
            {this.props.items.map(link => (
              <List.Item
                as="span"
                key={link.id}
                onClick={() =>
                  this.setState({
                    linkId: link.id,
                    linkLabel: link.label,
                    isModalOpen: true
                  })
                }
                style={{ cursor: "pointer" }}
                className="navlink"
              >
                <Icon name="chevron right" />
                <List.Content>{link.label}</List.Content>
              </List.Item>
            ))}
          </List>
        )}

        {this.state.isModalOpen ? (
          <FaqModal
            label={this.state.linkLabel}
            onClose={this.handleClose}
            content={this.state.content}
            faqId={this.state.linkId}
          />
        ) : null}
      </>
    )
  }
}

FaqLinks.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired
}

FaqLinks.defaultProps = {
  items: []
}

export const FaqLink = ({ item }) => <FaqLinks items={[item]} />

export default FaqLinks
